import type {
  rewardDetailResource,
  rewardResource,
} from '@porotutu/api/features/crm/rewards/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { REWARDS } from '@/api/keys'
import type { CrmRewardSort, RewardType } from '../vocabulary'

export type Reward = ReturnType<typeof rewardResource>
export type RewardDetail = ReturnType<typeof rewardDetailResource>

export type RewardPage = { data: Reward[]; meta: ListMeta }

export type RewardListQuery = ListQuery<CrmRewardSort, never> & {
  reward_type?: RewardType
  source_campaign_id?: string
}

export const rewardsQuery = (query: RewardListQuery) =>
  queryOptions({
    queryKey: [...REWARDS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.rewards.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const rewardQuery = (id: string) =>
  queryOptions({
    queryKey: [...REWARDS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.rewards({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<RewardListQuery>('/api/v1/crm/rewards/export', {
  always: ['source_campaign_id'],
  viewed: ['reward_type', 'search'],
})
